import React, { useReducer, useEffect } from "react";

import { validate } from "../util/validators";
import "./Input.css";

function inputReducer(state, action) {
  switch (action.type) {
    case "CHANGE":
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators),
      };
    case "TOUCH":
      return {
        ...state,
        isTouched: true,
      };
    case "UN-TOUCHED":
      return{
        ...state,
        isTouched: false
      }
    default:
      return state;
  }
}

function Input(props) {
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: props.initialValue || "",
    isValid: props.initialValid || false,
    isTouched: false,
  });

  const { id, onInput } = props;
  const { value, isValid } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  function changeHandler(event) {
    dispatch({
      type: "CHANGE",
      val: event.target.value,
      validators: props.validators,
    });
  }
  function touchHandler() {
    dispatch({
      type: "TOUCH",
    });
  }
  function untouchHandler() {
    dispatch({
      type: "UN-TOUCHED",
    });
  }
  

  const element =
    props.element === "input" ? (
      <input
        className="form-control"
        id={props.id}
        type={props.type}
        placeholder={props.placeholder}
        onChange={changeHandler}
        onBlur={touchHandler}
        onInput={untouchHandler}
        value={inputState.value}
      />
    ) : (
      <textarea
        className="form-control"
        id={props.id}
        rows={props.rows || 3}
        onChange={changeHandler}
        placeholder={props.placeholder}
        onBlur={touchHandler}
        onInput={untouchHandler}
        value={inputState.value}
      />
    );

  return (
    <div
      className={`form-group ${
        !inputState.isValid && inputState.isTouched && "form-control--invalid"
      }`}
    >
      {element}
      {!inputState.isValid && inputState.isTouched && <p>{props.errorText}</p>}
      {/* </div> */}
    </div>
  );
}

export default Input;
